import styled, { css } from 'styled-components';
import { BadgeProps } from '.';
import { colorSemanticsArray } from '@/styles/theme';

export const Container = styled.div<BadgeProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  background-color: ${({ theme, $color, $variant }) => {
    if (['outline', 'soft', 'ghost'].includes($variant)) return 'transparent';
    if ($color.includes('#')) return $color;
    if (colorSemanticsArray.includes($color))
      return theme.colors.semantic[$color]['9'];
    if ($variant === 'solid') return theme.colors[$color][$color]['9'];
    if ($variant === 'surface')
      return theme.colors[$color][`${$color}_${$variant}`]['7'];
  }};

  border: ${({ theme, $color, $variant, $borderColor }) => {
    if ($borderColor) return `1px solid ${$borderColor}`;
    if (['outline', 'soft'].includes($variant)) {
      return `1px solid ${theme.colors[$color][`${$color}_alpha`][$variant === 'outline' ? '8' : '7']}`;
    }
    return 'none';
  }};

  ${({ theme, $size, $rounded }) => {
    if ($size === 1 && $rounded) {
      return css`
        border-radius: 50%;
        width: ${theme.spacing[4]}px;
        height: ${theme.spacing[4]}px;
        justify-content: center;
      `;
    }
    return css`
      border-radius: ${$rounded ? '50%' : `${theme.radius['2']}px`};
      padding-top: ${theme.spacing[1]}px;
      padding-right: ${theme.spacing[$size]}px;
      padding-bottom: ${theme.spacing[1]}px;
      padding-left: ${theme.spacing[$size]}px;
      gap: ${theme.spacing[2]}px;
    `;
  }}
`;

export const Texto = styled.span<BadgeProps>`
  ${({ theme, $size, $textColor, $color }) => {
    function retornarCorTexto() {
      if ($textColor) return $textColor;
      if ($color) {
        if (
          colorSemanticsArray.includes($color) &&
          !['success', 'warning'].includes($color)
        ) {
          return theme.colors.semantic[$color][12];
        }
      }
      return theme.tokens.colors.accent_contrast;
    }

    return css`
      font-size: ${theme.typography.font.size[$size]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height[$size]}px;
      text-align: center;
      color: ${retornarCorTexto()};
    `;
  }};
`;
